import React, { createContext, useContext, useState, useEffect } from "react";

interface LayoutContextType {
  exhibitionMode: boolean;
  setExhibitionMode: (val: boolean) => void;
}

const LayoutContext = createContext<LayoutContextType>({
  exhibitionMode: false,
  setExhibitionMode: () => {},
});

export const useLayout = () => useContext(LayoutContext);

export const LayoutProvider = ({ children }: { children: React.ReactNode }) => {
  const [exhibitionMode, setExhibitionMode] = useState(false);

  useEffect(() => {
    // I think I set this on the werkschau Raspi :)
    const kiosk = process.env.REACT_APP_KIOSK_MODE === "true";
    // Fix for imac exhibition vcfso25
    const imacExhibition =
      window.location.pathname.indexOf("/exhibits/imac") !== -1;
    if (exhibitionMode && (kiosk || imacExhibition)) {
      console.log("Exhibition mode enabled");
      document.documentElement.style.cursor = "none";
    } else {
      document.documentElement.style.cursor = "";
    }
  }, [exhibitionMode]);

  return (
    <LayoutContext.Provider value={{ exhibitionMode, setExhibitionMode }}>
      {children}
    </LayoutContext.Provider>
  );
};
